import React from 'react';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MainNavbar, MainFooter, AutoLexiLogo, SidePanels } from 'components';
import { WordListPage, SubscriptionPage, FlashcardPage, HelpPage, AuthorPage } from 'pages';
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { SessionStatsProvider, AccountStatsProvider } from 'context';

const AppContent = () => {
  const auth = useAuth();
  const location = useLocation();

  return (
    <div>
      <MainNavbar />
      <div className="content">
        {auth.isAuthenticated ? <><AutoLexiLogo /><p className="hide-on-mobile">Learn by reading</p></> : <><h1>Welcome to AutoLexi!</h1><p>Learn by reading</p></>}
      </div>
      {(location.pathname !== '/account' && auth.isAuthenticated)  && <SidePanels />}
      <Routes>
        <Route path="/" element={auth.isAuthenticated ? <FlashcardPage /> : <HelpPage />} />
        <Route path="/wordlist" element={<WordListPage />} />
        <Route path="/account" element={<SubscriptionPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/about" element={<AuthorPage />} />
      </Routes>
      <MainFooter />
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <SessionStatsProvider>
      <AccountStatsProvider>
        <AppContent />
      </AccountStatsProvider>
    </SessionStatsProvider>
  </BrowserRouter>
);

export {App};